// adminSaga.ts

import { call, put, select,takeLatest } from "redux-saga/effects";

import { API } from "../../api";
import {
  activateAdmin,
  activateAdminFailure,
  activateAdminSuccess,
  addAdmin,
  addAdminFailure,
  addAdminSuccess,
  getAdmins,
  getAdminsFailure,
  getAdminsSuccess,
  getFilteredAdmins,
  getFilteredAdminsFailure,
  getFilteredAdminsSuccess,
  inviteAdmin,
  inviteAdminFailure,
  inviteAdminSuccess,
  removeAdmin,
  removeAdminFailure,
  removeAdminSuccess,
  updateAdmin,
  updateAdminFailure,
  updateAdminSuccess,
} from "../reducers/adminsSlice";

import { errorHandler } from "./common";

function* getAdminsSaga () {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, `/admins`, {
      params: {
        limit: "500",
      },
      headers: {
        Authorization: `Bearer ${  token}`,
        "Access-Control-Allow-Origin": "*",
      },
    });

    yield put(getAdminsSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: getAdminsSaga,
      *callback () {
        yield put(getAdminsFailure(error));
      },
    });
  }
}

function* getFilteredAdminsSaga (action: any) {
  try {
    const searchParams = action.payload;
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, `/admins`, {
      params: {
        limit: "500",
        ...searchParams,
      },
      headers: {
        Authorization: `Bearer ${  token}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    yield put(getFilteredAdminsSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield getFilteredAdminsSaga(action);
      },
      *callback () {
        yield put(getFilteredAdminsFailure(error));
      },
    });
  }
}

function* addAdminSaga ({
  payload: { token, password, onSuccess, onFailure },
}: {
  payload: {
    token: string;
    password: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}) {
  try {
    // @ts-ignore
    yield call<any>(API.post, "/admins", {
      token,
      password,
    });

    yield put(addAdminSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield addAdminSaga({
          payload: { token, password, onSuccess, onFailure },
        });
      },
      *callback () {
        yield put(addAdminFailure(error));
        onFailure(error);
      },
    });
  }
}

function* inviteAdminSaga ({
  payload: { firstName, lastName, email, studios, photo, onSuccess, onFailure },
}: {
  payload: {
    firstName: string;
    lastName: string;
    email: string;
    studios?: string[];
    photo: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      "/admins/invite",
      {
        firstName,
        lastName,
        email,
        studios,
        photo,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(inviteAdminSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield inviteAdminSaga({
          payload: {
            firstName,
            lastName,
            email,
            studios,
            photo,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(inviteAdminFailure(error));
        onFailure(error);
      },
    });
  }
}

function* updateAdminSaga ({
  payload: {
    id,
    firstName,
    lastName,
    email,
    photo,
    studios,
    onSuccess,
    onFailure,
  },
}: {
  payload: {
    id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    photo?: string;
    studios?: string[];
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.patch,
      `/admins/${id}`,
      {
        firstName,
        lastName,
        email,
        photo,
        studios,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(updateAdminSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield updateAdminSaga({
          payload: {
            id,
            firstName,
            lastName,
            email,
            photo,
            studios,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(updateAdminFailure(error));
        onFailure(error);
      },
    });
  }
}

function* removeAdminSaga ({
  payload: { id, onSuccess, onFailure },
}: {
  payload: {
    id: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(API.delete, `/admins/${id}`, {
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(removeAdminSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield removeAdminSaga({
          payload: { id, onSuccess, onFailure },
        });
      },
      *callback () {
        yield put(removeAdminFailure(error));
        onFailure(error);
      },
    });
  }
}

function* activateAdminSaga ({
  payload: { id, onSuccess, onFailure },
}: {
  payload: {
    id: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      `/admins/${id}/activate`,
      {},
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      });

    yield put(activateAdminSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield activateAdminSaga({
          payload: { id, onSuccess, onFailure },
        });
      },
      *callback () {
        yield put(activateAdminFailure(error));
        onFailure(error);
      },
    });
  }
}

// Watcher Saga
export function* adminsSaga () {
  // @ts-ignore
  yield takeLatest(getAdmins().type, getAdminsSaga);
  // @ts-ignore
  yield takeLatest(getFilteredAdmins().type, getFilteredAdminsSaga);
  // @ts-ignore
  yield takeLatest(addAdmin().type, addAdminSaga);
  // @ts-ignore
  yield takeLatest(inviteAdmin().type, inviteAdminSaga);
  // @ts-ignore
  yield takeLatest(updateAdmin().type, updateAdminSaga);
  // @ts-ignore
  yield takeLatest(removeAdmin().type, removeAdminSaga);
  // @ts-ignore
  yield takeLatest(activateAdmin().type, activateAdminSaga);
}
